import BaseModulePlugins from '@/store/baseModule/plugins';
import router from '@/router';
import { ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME } from '@/router/actions.router';
import { ACTIONS_LIST_ROUTE_NAME } from '@/router/rootActions.router';
import {
  formatDateToInputDate,
  formatDateToInputDateTime,
} from '@/business/utils/dates';

export function formatActionItem(partialItem) {
  return {
    description: partialItem.description,
    node_id: partialItem.node_id,
    staffs_in_charge_id: partialItem.staffs_in_charge_id
      ? partialItem.staffs_in_charge_id
          .split(',')
          .map((idString) => Number(idString))
      : [],
    priority_id: partialItem.priority_id,
    start_datetime: formatDateToInputDate(partialItem.start_datetime),
    deadline_datetime: formatDateToInputDate(partialItem.deadline_datetime),
    id: partialItem.id,
    documents_number: partialItem.documents_number,
    action_status: {
      type_id: partialItem.current_action_status_type_id,
      datetime: formatDateToInputDateTime(
        partialItem.current_action_status_datetime
      ),
    },
    type_id: partialItem.type_id,
    on_site: !!partialItem.on_site,
    daybook: partialItem.daybook === 'O',
    customer_shared_description:
      partialItem.customer_shared_description === 'O',
    daybook_forced: false,
  };
}

export default (store, modulePath) => {
  const basePlugin = new BaseModulePlugins({
    paramId: 'actionplanId',
    module: modulePath,
    store,
  });

  basePlugin.setCurrentLoading();
  basePlugin.onInit(() => {
    basePlugin.loadCurrentOnRouteParamsChange('actionId');
    basePlugin.persistVuexMutationsToLocalStorage([
      'SET_ATTRIBUTES_OBJ',
      'SET_ITEMS_SORT_BY',
      'SET_VIEW_TABLE',
      'SET_ORDER_ASC',
    ]);
    basePlugin.loadItemsOnCurrentChange({
      attribute: 'action_plan_id',
      serverSide: true,
    });

    basePlugin.onItemAddedOrModified(() => {
      if (store.getters[`${modulePath}/attributesObj`].action_plan_id) {
        store.dispatch(`${modulePath}/refreshItems`);
      }
      store.dispatch('actions/refreshItems');
    });

    store.subscribe((mutation, state) => {
      if (
        mutation.type === `${modulePath}/UPDATE_SUCCESS` &&
        state.RouteModule.name !== ACTIONS_LIST_ROUTE_NAME
      ) {
        store.dispatch(`${modulePath}/setCurrent`, mutation.payload);
      }
    });

    basePlugin.onItemDeleted(() => {
      store.dispatch(`${modulePath}/refreshItems`);
      store.dispatch('actions/refreshItems');
      router.push({
        name: ACTIONPLAN_ACTIONS_LIST_ROUTE_NAME,
      });
    });

    store.subscribe((mutation) => {
      if (
        mutation.type === 'documents/SET_ITEMS' &&
        !!store.getters['documents/actionId']
      ) {
        const action = { ...store.getters[`${modulePath}/current`] };

        const count = store.getters['documents/count'];
        if (count !== action.documents_number) {
          const actionItem = formatActionItem(action);
          actionItem.documents_number = count;
          store.dispatch(`${modulePath}/updateItem`, actionItem);
        }
      }
    });
  });
};
